import { gql } from 'graphql-request';

export default gql`
  fragment NewsCard on NewsPage {
    shortTitle
    introduction
    url
    image {
      ... on ImageObjectType {
        title
        lg: rendition(fill: "480x260-c100") {
          url
        }
        sm: rendition(fill: "290x150-c100") {
          url
        }
      }
    }
  }
`;
